import {Reducer} from 'redux'
import {ReportsActionTypes, ReportsState} from './types';
import ReportsService from "../../services/ReportsService";
import * as moment from "moment"

// Type-safe initialState!
const initialState: ReportsState = {
	list: [],
	from: moment(Date()).subtract(6,'month').toDate(),
	to: new Date(),
	rawList: [],
	servicesRawList: [],
	servicesList: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<ReportsState> = (state = initialState, action) => {
	switch (action.type) {
		case ReportsActionTypes.FETCH_INVOICE_AND_PAYMENTS_REQUEST: {
			ReportsService.getInvoicesAndPaymentsPerPeriod()
			return state
		}
		case ReportsActionTypes.FETCH_INVOICE_AND_PAYMENTS_COMPLETED: {
			let data = ReportsService.prepareReport(action.payload, state.from, state.to)
			return { ...state, rawList: action.payload, list: data}
		}
		case ReportsActionTypes.SET_FROM_DATE: {
			let data = ReportsService.prepareReport(state.rawList, action.payload, state.to)
			return { ...state, from: action.payload, list: data}
		}
		case ReportsActionTypes.SET_TO_DATE: {
			let data = ReportsService.prepareReport(state.rawList, state.from, action.payload)
			return { ...state, to: action.payload, list: data}
		}
		case ReportsActionTypes.FETCH_SERVICES_REQUEST: {
			let fromDate = action.payload.fromDate
			let toDate = action.payload.toDate
			ReportsService.getServicesPerPeriod(fromDate, toDate)
			return state
		}
		case ReportsActionTypes.FETCH_SERVICES_COMPLETED: {
			let data = ReportsService.prepareBookingReport(action.payload)
			return { ...state, servicesRawList: action.payload, servicesList: data}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as ReportsReducer}
